"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports._to = exports.checkIfProvider = exports.checkIfUserDefinedProvider = void 0;
/**
 * Utility for typechecking UserDefinedProvider objects
 *
 * @export
 * @param {(UserDefinedProvider | any)} userDefinedProvider - The UserDefinedProvider object to be checked
 * @returns {u is UserDefinedProvider}
 */
function checkIfUserDefinedProvider(userDefinedProvider) {
    return (userDefinedProvider.name !== undefined &&
        checkIfProvider(userDefinedProvider.provider));
}
exports.checkIfUserDefinedProvider = checkIfUserDefinedProvider;
/**
 * Utility for typechecking Provider objects
 *
 * @export
 * @param {(Provider | any)} provider - The Provider object to be checked
 * @returns {p is Provider}
 */
function checkIfProvider(provider) {
    return (provider.endpoint !== undefined &&
        provider.errorHandler !== undefined &&
        provider.errors !== undefined &&
        provider.handler !== undefined &&
        provider.key !== undefined);
}
exports.checkIfProvider = checkIfProvider;
/**
 * Wraps a promise and handles both the resolved value and any potential errors.
 * @param promise - The promise to wrap.
 * @returns A promise that resolves to a tuple containing the error (if any) and the resolved value (if any).
 */
function _to(promise) {
    return promise
        .then((data) => [null, data])
        .catch((err) => [err, null]);
}
exports._to = _to;
/**
 * Delays execution by the specified amount of time.
 *
 * @param ms - The number of milliseconds to wait.
 * @returns A promise that resolves after the specified delay.
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.sleep = sleep;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcGFydHMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUE7Ozs7OztHQU1HO0FBQ0gsU0FBZ0IsMEJBQTBCLENBQ3hDLG1CQUE4QztJQUU5QyxPQUFPLENBQ0osbUJBQTJDLENBQUMsSUFBSSxLQUFLLFNBQVM7UUFDL0QsZUFBZSxDQUFFLG1CQUEyQyxDQUFDLFFBQVEsQ0FBQyxDQUN2RSxDQUFDO0FBQ0osQ0FBQztBQVBELGdFQU9DO0FBRUQ7Ozs7OztHQU1HO0FBQ0gsU0FBZ0IsZUFBZSxDQUM3QixRQUF3QjtJQUV4QixPQUFPLENBQ0osUUFBcUIsQ0FBQyxRQUFRLEtBQUssU0FBUztRQUM1QyxRQUFxQixDQUFDLFlBQVksS0FBSyxTQUFTO1FBQ2hELFFBQXFCLENBQUMsTUFBTSxLQUFLLFNBQVM7UUFDMUMsUUFBcUIsQ0FBQyxPQUFPLEtBQUssU0FBUztRQUMzQyxRQUFxQixDQUFDLEdBQUcsS0FBSyxTQUFTLENBQ3pDLENBQUM7QUFDSixDQUFDO0FBVkQsMENBVUM7QUFHRDs7OztHQUlHO0FBQ0gsU0FBZ0IsR0FBRyxDQUNqQixPQUFtQjtJQUVuQixPQUFPLE9BQU87U0FDWCxJQUFJLENBQUMsQ0FBQyxJQUFPLEVBQWEsRUFBRSxDQUFDLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxDQUFDO1NBQzFDLEtBQUssQ0FBQyxDQUFDLEdBQU0sRUFBYSxFQUFFLENBQUMsQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQztBQUMvQyxDQUFDO0FBTkQsa0JBTUM7QUFHRDs7Ozs7R0FLRztBQUNILFNBQWdCLEtBQUssQ0FBQyxFQUFVO0lBQzlCLE9BQU8sSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxVQUFVLENBQUMsT0FBTyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUM7QUFDekQsQ0FBQztBQUZELHNCQUVDIn0=